import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { exists, generateHex, resolveContent } from '@nu-art/ts-common';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import './TS_CheckboxV2.scss';
import { TS_Icons } from '@nu-art/ts-styles';
export class TS_CheckboxV2 extends ComponentSync {
    defaultIconSpec = {
        checked: () => _jsx(TS_Icons.v.component, {}),
        unChecked: () => _jsx(TS_Icons.x.component, {}),
        indeterminate: () => _jsx(TS_Icons.dash.component, {}),
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.checked = nextProps.checked;
        state.disabled = !!nextProps.disabled;
        state.label = nextProps.label;
        state.id ??= nextProps.id ?? generateHex(8);
        state.className = nextProps.className;
        state.customIcons = nextProps.customIcons;
        return state;
    }
    //######################### Logic #########################
    onChange = (e) => {
        const next = e.target.checked;
        e.stopPropagation();
        this.props.onCheck(next);
    };
    resolveIconNode = () => {
        const spec = this.state.customIcons ?? this.defaultIconSpec;
        return exists(this.state.checked)
            ? (this.state.checked
                ? spec.checked
                : spec.unChecked) : spec.indeterminate;
    };
    //######################### Render #########################
    render() {
        const className = _className('ts-checkbox-v2', this.state.className);
        return _jsxs("label", { className: className, onClick: e => e.stopPropagation(), children: [this.render_Input(), this.render_Icon(), this.render_Label()] });
    }
    render_Input = () => {
        const checked = this.state.checked;
        const ariaChecked = exists(checked) ? (checked ? 'true' : 'false') : 'mixed';
        return _jsx("input", { type: 'checkbox', id: this.state.id, disabled: this.state.disabled, onChange: this.onChange, checked: !!this.state.checked, "aria-checked": ariaChecked });
    };
    render_Icon = () => {
        const iconNode = resolveContent(this.resolveIconNode());
        return _jsx("span", { className: 'ts-checkbox-v2__icon', children: iconNode });
    };
    render_Label = () => {
        return _jsx("span", { className: 'ts-checkbox-v2__label', children: this.state.label });
    };
}
//# sourceMappingURL=TS_CheckboxV2.js.map